/* eslint-disable */
import axios from 'axios';
import { stat } from 'fs';


export default {

    state : {
        prices : [],
        price : [],
        postPrice : [],
        notSaved : [],
        notPostSaved : [],
        priceId : null,
    },

   

   
    getters : {
        
        
        savedPostStatus(state) {
            return state.notPostSaved.length > 0;
        },

        anyNotSaved(state) {
            return ((state.notSaved.length > 0) || (state.notPostSaved.length > 0));
        },

        savedStatus :(state) => (direction) => {
            var s = state.notSaved.find((item)=>{ //ищем статус данного направления
                return (item.direction == direction);
            });
            if (s == undefined) return false
            else return s.status;
        },

        allPrices(state) {
            return state.prices;
        },

        getPriceById: (state) => (id) => {
            state.priceId = id; // сохраняем текущий priceId
            return state.prices.find(item => item.id === id)
        },

        getPrice: (state)=>(direction, mat, q) => { //возвращает текущую цену из прайса
            return state.price.find((item) => {
                return (item.direction==direction) && (item.quality==q) && (item.matId==mat);
            })
        },

        getPostPrice: (state) => (postId) => {
            return state.postPrice.find((item) => {
                return (item.post_type == postId);
            })
        },

    },
    

    mutations: {

        clearPricesData() {
            console.log('clearPricesData')
        },

        addPostPrice(state) {
            console.log('затычка постпрайс коммит')
        },

        priceSaved(state){

            for (let i = 0; i<state.price.length; i++) {
                let q = state.price[i];
                if (q.changed != undefined) {
                    q.changed = false;
                }
                state.price.splice(i, 1, q);
            }
            state.notSaved.splice(0, state.notSaved.length);

            for (let i = 0; i<state.postPrice.length; i++) {
                let q = state.postPrice[i];
                if (q.changed != undefined) {
                    q.changed = false;
                }
                state.postPrice.splice(i, 1, q);
            }
            state.notPostSaved.splice(0, state.notPostSaved.length);

        },

        setPriceId(state, priceId) {
            state.priceId = priceId;
        },

        addPrice(state, data) {
            if (data.length>0) state.price = data[0]; // В НУЛЕВОМ ЭЛЕМЕНТЕ СОДЕРЖИТСЯ ОСНОВНОЙ ПРАЙС
            if (data.length>1) state.postPrice = data[1]; //в первом прайс на постобработку.ф
        },

        addNewPrice(state, data) {

            state.prices.push(data); // добавляем новый

        },

        retrievePrices(state, data) {
            state.prices = data;
        },
        
        temporarilySavePostPrice(state, data) {
            var priceItem = state.postPrice.find((item) => {return (item.post_type == data.post_type)});
            if (priceItem != undefined) {
                priceItem.cost = data.cost;
                priceItem.changed = true;
                
           } else { // значит такой цены не существует - надо бы добавить
                data.changed = true;
                data.price_Id = state.priceId;
                state.postPrice.push(data); // тупо пока добавляем в локаль - потом будем уже добавлять в базу
           }
           var status = true;
           var s = state.notPostSaved.find((item)=>{ //ищем статус данного направления
                return (item.post_type == data.post_type); 
            });
            if (s != undefined) {s.status = status;}
            else state.notPostSaved.push({post_type:data.post_type, status: status});

        },

        temporarilySavePrice(state, data) {

           var priceItem = state.price.find((item) => {return (item.direction == data.direction) && (item.quality == data.quality) && (item.matId == data.matId)});

           if (priceItem != undefined) {
                priceItem.price = data.price;
                priceItem.changed = true;
                
           } else { // значит такой цены не существует - надо бы добавить
                data.changed = true;
                data.priceId = state.priceId;
                state.price.push(data); // тупо пока добавляем в локаль - потом будем уже добавлять в базу
           }

           var status = true;
           var s = state.notSaved.find((item)=>{ //ищем статус данного направления
                return (item.direction == data.direction); 
            });
            if (s != undefined) {s.status = status;}
            else state.notSaved.push({direction:data.direction, status: status});
        }

    },

    actions : {

        savePrice({ commit, state }) {
            
            return new Promise((resolve, reject) => {

                    axios.post('/price/' + state.priceId, 
                        {
                            mainPrice :  state.price,
                            postPrice :  state.postPrice
                        }
                    )
                    .then(response => {
                         commit('priceSaved');
                         resolve(response);
                    })
                    
                    .catch(error => {
                        reject(error)
                    });
            });
        },

        retrievePrices({dispatch, commit, rootState}) {
            return new Promise((resolve, reject) => {
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;

                    axios.get('/prices')
                    .then(response => {
                        if (!response) return;
                        commit('retrievePrices', response.data)                 
                    })
                    .catch(error => {
                        if (!error) return;
                        if ((error.response.status == 401)||(error.response.status == 500)) {
                        }
                        else {
                            let t = error.response.status == 429 ? 15000 : 1500;
                            if (error.response != undefined) 
                                if (error.response.headers["retry-after"] != undefined) t = error.response.headers["retry-after"];
                                setTimeout(()=>{        // повторная загрузка через секунду
                                    dispatch('retrievePrices');
                                }, t);
                            // console.log(error.response.status);
                        }
                    });
            });
        },

        getPriceById({dispatch, commit, rootState}, id) {
            
            return new Promise((resolve, reject) => {

                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.token;
                axios.get('/price/' + id)
                .then(response => {
                    if (!response) return;
                    commit('addPrice', response.data);
                    commit('setPriceId', id);
                    resolve(response);
                })
                .catch(error => {
                    if ((error.response.status == 401)||(error.response.status == 500)) {
                        console.log(error)
                    }
                    else {
                        let t = error.response.status == 429 ? 15000 : 1500;
                        if (error.response != undefined) 
                            if (error.response.headers["retry-after"] != undefined) t = error.response.headers["retry-after"];

                        setTimeout(()=>{        // повторная загрузка 
                            dispatch('getPriceById', id);
                        }, t);
                    }
                    reject(error)
                });
            });
        },


        createNewPrice(context, data) {

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + context.rootState.token;

            return new Promise((resolve, reject) => {
                axios
                    .post('/addPrice', data)
                    .then(response => {
                        context.commit('addNewPrice', response.data);
                        resolve(response.data.id);
                    })
                    .catch(error => {
                        reject(error)
                    });
            });

        }

    }

}